import { NgModule } from '@angular/core';
import {CoreModule} from "../core/core.module";
import {PortalSearchModule} from "./portal-page/components/portal-search/portal-search.module";
import { RUNTIME_COMPILER_PROVIDERS } from './runtime-compiler.providers';

import {FormioModule} from "@formio/angular";

import {PortalDynamicModule} from "./portal-page/components/portal-dynamic/components/portal-dynamic.module";
import {PortalPageModule} from "./portal-page/portal-page.module";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {HomePageModule} from "./home-page/home-page.module";
import {EmptyPageComponent} from "./empty-page/empty-page.component";
import {KnockoutPageComponent} from "./knockout-page/knockout-page.component";
import {PortalPageComponent} from "./portal-page/portal-page.component";
import {QuestionOverlayComponent} from "./catalog-page/components/question-overlay/question-overlay.component";
import {ActionQuestionOverlayComponent} from "./catalog-page/components/action-question-overlay/action-question-overlay.component";
import {SearchPageComponent} from "./search-page/search-page.component";
import {SearchResultComponent} from "./search-page/components/search-result/search-result.component";
import {PortalDynamicComponent} from "./portal-page/components/portal-dynamic/portal-dynamic.component";
import {DynamicFormioComponent} from "./portal-page/components/dynamic-formio/dynamic-formio.component";
import {CatalogPageModule} from "./catalog-page/catalog-page.module";
import {ColorPickerModule} from "ngx-color-picker";
import {SurveyPageComponent} from './survey-page/survey-page.component';
import { ImportDataComponent } from './import-page/components/import-data/import-data.component';
import { LoadRecordsComponent } from './import-page/components/load-records/load-records.component';
import { ScheduleImportDataComponent } from './import-page/components/schedule-import-data/schedule-import-data.component';
import { ScheduleLoadRecordsComponent } from './import-page/components/schedule-load-records/schedule-load-records.component';
import { CmdbPageComponent } from './cmdb-page/cmdb-page.component';
import {GojsModule} from "../gojs/gojs.module";
import { CmdbDefaultInfoboxComponent } from './cmdb-page/components/cmdb-default-infobox/cmdb-default-infobox.component';
import { CmdbInfoboxComponent } from './cmdb-page/components/cmdb-infobox/cmdb-infobox.component';
import { ReportPageComponent } from './report-page/report-page.component';
import { AuditPageComponent } from './audit-page/audit-page.component';
import { AuditHistoryRecordComponent } from './audit-page/components/audit-history-record/audit-history-record.component';
import { AuditHistoryGroupComponent } from './audit-page/components/audit-history-group/audit-history-group.component';
import { AuditHistoryHeaderComponent } from './audit-page/components/audit-history-header/audit-history-header.component';
import { AuditHistoryTextFieldComponent } from './audit-page/components/audit-history-text-field/audit-history-text-field.component';
import { AuditHistoryTextAreaComponent } from './audit-page/components/audit-history-text-area/audit-history-text-area.component';
import { PermissionEvaluationPageComponent } from './permission-evaluation-page/permission-evaluation-page.component';
import {WorkflowPageComponent} from "./workflow-page/workflow-page.component";
import { ScheduleModule } from "@syncfusion/ej2-angular-schedule";
import { MapPageComponent } from './map-page/map-page.component';
import {GoogleMapsModule} from "@angular/google-maps";

import { PivotReportPageComponent } from './pivotreport-page/pivotreport-page.component';
import {PivotViewAllModule} from "@syncfusion/ej2-angular-pivotview";
import {
    AccordionModule, BreadcrumbAllModule,
    ContextMenuModule,
    TabModule,
    ToolbarModule,
    TreeViewAllModule
} from "@syncfusion/ej2-angular-navigations";
import {GridModule, PagerAllModule} from "@syncfusion/ej2-angular-grids";
import {
    ButtonModule,
    CheckBoxModule,
    ChipListAllModule,
    RadioButtonModule,
    SwitchModule
} from "@syncfusion/ej2-angular-buttons";
import {DropDownListModule, MultiSelectModule} from "@syncfusion/ej2-angular-dropdowns";
import {TimePickerModule} from "@syncfusion/ej2-angular-calendars";
import {MaskedTextBoxAllModule, TextBoxModule} from "@syncfusion/ej2-angular-inputs";
import {DialogModule, TooltipAllModule} from "@syncfusion/ej2-angular-popups";
import { SlaReportPageComponent } from './slareport-page/slareport-page.component';
import { KnowledgePageComponent } from './knowledge-page/knowledge-page.component';
import {RichTextEditorModule} from "@syncfusion/ej2-angular-richtexteditor";
import { WorkflowModalComponent } from './workflow-page/workflow-modal/workflow-modal.component';
import { PortalModalComponent } from './portal-page/portal-modal/portal-modal.component';
import {SearchResultModule} from "./search-page/components/search-result/components/search-result.module";
import { ForwardScheduleOfChangePageComponent } from './forward-schedule-of-change-page/forward-schedule-of-change-page.component';
import { ResourceAllocationSchedulePageComponent } from './resource-allocation-schedule-page/resource-allocation-schedule-page.component';
import { CreateTransformMapComponent } from './import-page/components/create-transform-map/create-transform-map.component';
import {ListViewAllModule} from "@syncfusion/ej2-angular-lists";
import { ScratchPageComponent } from './scratch-page/scratch-page.component';
import { SecondFactorAuthPageComponent } from './second-factor-auth-page/second-factor-auth-page.component';
import {QRCodeGeneratorModule} from "@syncfusion/ej2-angular-barcode-generator";

import {SplitterAllModule} from "@syncfusion/ej2-angular-layouts";
import {PortalComponentsModule} from "./portal-page/portal-components.module";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {EditorComponent} from "@tinymce/tinymce-angular";
import { SharedModule } from '../shared/shared.module';
import {KanbanAllModule} from "@syncfusion/ej2-angular-kanban";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        HomePageModule,
        CoreModule,
        PortalSearchModule,
        PortalDynamicModule,
        FormioModule,
        PortalPageModule,
        CatalogPageModule,
        ColorPickerModule,
        GojsModule,
        ScheduleModule,
        GoogleMapsModule,
        AccordionModule,
        TabModule,
        GridModule,
        CheckBoxModule,
        ToolbarModule,
        SwitchModule,
        ContextMenuModule,
        ButtonModule,
        DropDownListModule,
        MultiSelectModule,
        TimePickerModule,
        TextBoxModule,
        RadioButtonModule,
        DialogModule,
        PivotViewAllModule,
        RichTextEditorModule,
        SearchResultModule,
        TreeViewAllModule,
        ListViewAllModule,
        ChipListAllModule,
        MaskedTextBoxAllModule,
        QRCodeGeneratorModule,
        SplitterAllModule,
        PagerAllModule,
        PortalComponentsModule,
        InfiniteScrollModule,
        BreadcrumbAllModule,
        EditorComponent,
        KanbanAllModule,
        TooltipAllModule,
    ],
  declarations: [
    EmptyPageComponent,
    KnockoutPageComponent,
    PortalPageComponent,
    QuestionOverlayComponent,
    ActionQuestionOverlayComponent,
    SearchPageComponent,
    SearchResultComponent,
    PortalDynamicComponent,
    PortalPageComponent,
    DynamicFormioComponent,
    SurveyPageComponent,
    ImportDataComponent,
    LoadRecordsComponent,
    ScheduleImportDataComponent,
    ScheduleLoadRecordsComponent,
    CmdbPageComponent,
    CmdbDefaultInfoboxComponent,
    CmdbInfoboxComponent,
    ReportPageComponent,
    AuditPageComponent,
    AuditHistoryRecordComponent,
    AuditHistoryGroupComponent,
    AuditHistoryHeaderComponent,
    AuditHistoryTextFieldComponent,
    AuditHistoryTextAreaComponent,
    PermissionEvaluationPageComponent,
    WorkflowPageComponent,
    MapPageComponent,
    PivotReportPageComponent,
    SlaReportPageComponent,
    KnowledgePageComponent,
    WorkflowModalComponent,
    ForwardScheduleOfChangePageComponent,
    PortalModalComponent,
    ResourceAllocationSchedulePageComponent,
    CreateTransformMapComponent,
    ScratchPageComponent,
    SecondFactorAuthPageComponent,
  ],
  exports: [
    EmptyPageComponent,
    KnockoutPageComponent,
    QuestionOverlayComponent,
    ActionQuestionOverlayComponent,
    SurveyPageComponent
  ],
  providers: [
    ...RUNTIME_COMPILER_PROVIDERS
  ]
})

export class PagesModule {
  constructor() {
  }
}
